<template>
    <!-- <el-dialog
        class="complete"
        :visible.sync="completeVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="450px"
        title="完成任务"
    >
        <div class="container">
            <el-form
                ref="completeForm"
                :rules="rules"
                :model="completeForm"
                label-width="auto"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="总耗时"
                            size="small"
                            prop="total_time"
                        >
                            <el-input
                                clearable
                                placeholder="请输入总耗时"
                                size="small"
                                v-model="completeForm.total_time"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" size="small" prop="remark">
                            <el-input
                                type="textarea"
                                clearable
                                placeholder="请输入备注"
                                :autosize="{ minRows: 5 }"
                                size="small"
                                v-model="completeForm.remark"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="completeVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog> -->
    <div class="complete">
        <p class="title">完成任务</p>
        <el-form
            ref="completeForm"
            :rules="rules"
            :model="completeForm"
            label-width="60px"
        >
            <el-row>
                <el-col :span="24">
                    <el-form-item label="总耗时" size="small" prop="total_time">
                        <el-input
                            clearable
                            placeholder="请输入总耗时"
                            size="small"
                            v-model="completeForm.total_time"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注" size="small" prop="remark">
                        <el-input
                            type="textarea"
                            clearable
                            placeholder="请输入备注"
                            :autosize="{ minRows: 5 }"
                            size="small"
                            v-model="completeForm.remark"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item size="small">
                        <el-button size="small" type="primary" @click="save"
                            >保存</el-button
                        >
                        <el-button size="small" @click="closeDialog"
                            >关闭</el-button
                        >
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";

export default {
    name: "complete",
    data() {
        return {
            completeForm: {
                total_time: 1,
                remark: "",
            },
            rules: {
                total_time: [
                    {
                        required: true,
                        message: "请输入总耗时",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    props: {
        completeVisible: Boolean,
        tableItem: Object,
        totalTime: Number,
    },
    watch: {
        totalTime: {
            handler(newVal) {
                this.completeForm.total_time = newVal;
            },
        },
    },
    created() {},
    methods: {
        /**
         * 保存
         */
        save() {
            this.$refs["completeForm"].validate((valid) => {
                if (valid) {
                    oaApi
                        .jobDetail(
                            {
                                job_id: this.tableItem.id,
                                total_time: this.completeForm.total_time,
                                remark: this.completeForm.remark,
                                status: "完成",
                            },
                            "post"
                        )
                        .then((res) => {
                            //console.log(res);
                            if (res.code == 200) {
                                this.$message.success(`完成成功`);
                                if(this.$parent.$parent.$parent.$parent && this.$parent.$parent.$parent.$parent.job) {
                                    this.$parent.$parent.$parent.$parent.job();
                                }else if (this.$parent.$parent.$parent.$parent.$parent.$parent && this.$parent.$parent.$parent.$parent.$parent.$parent.job) {
                                    this.$parent.$parent.$parent.$parent.$parent.$parent.job();
                                }
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:completeVisible", false);
            this.$parent.doClose();
            this.$refs["completeForm"].resetFields();
            this.$refs["completeForm"].clearValidate();
        },
        /**
         * 获取指派人总耗时
         */
        jobDetailTotalTime() {
            oaApi
                .jobDetailTotalTime({ job_id: this.tableItem.id }, "get")
                .then((res) => {
                    //console.log(res);
                    if (res.code == 200) {
                        this.completeForm.total_time = res.data.hour;
                    }
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.complete {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
    }

    .title {
        padding-bottom: 10px;
        border-bottom: 1px solid #c0c6cc;
        margin-bottom: 10px;
    }
}
</style>